import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Upload as UploadIcon, MessageCircle, Activity, LogOut, Users } from 'lucide-react';
import { authUtils } from './utils/auth';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import WhatsAppConnect from './pages/WhatsAppConnect';
import Tracking from './pages/Tracking';
import UserManagement from './pages/UserManagement';
import './App.css';

function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname === path;
  
  const user = authUtils.getUser();
  const canAccessTracking = authUtils.canAccessTracking();
  const canManageUsers = authUtils.canManageUsers();

  const handleLogout = () => {
    authUtils.removeToken();
    navigate('/login');
  };

  // Get role badge
  const getRoleBadge = () => {
    if (!user) return '';
    const badges = {
      super_admin: '👑 Admin',
      spv: '👨‍💼 SPV',
      operator: '👤 Operator'
    };
    return badges[user.role] || user.role;
  };

  return (
    <nav className="sidebar">
      <div className="logo">
        <h2>🚀 Blaster System</h2>
        {user && (
          <div className="user-info">
            <p><strong>{user.full_name || user.username}</strong></p>
            <p style={{fontSize: '12px', marginTop: '4px'}}>{getRoleBadge()}</p>
            {user.brand && <p style={{fontSize: '11px', color: 'rgba(255,255,255,0.6)'}}>📦 {user.brand}</p>}
          </div>
        )}
      </div>

      <ul className="nav-links">
        <li className={isActive('/dashboard') ? 'active' : ''}>
          <Link to="/dashboard">
            <Home size={20} />
            <span>Dashboard</span>
          </Link>
        </li>

        <li className={isActive('/upload') ? 'active' : ''}>
          <Link to="/upload">
            <UploadIcon size={20} />
            <span>Upload Data</span>
          </Link>
        </li>

        <li className={isActive('/whatsapp') ? 'active' : ''}>
          <Link to="/whatsapp">
            <MessageCircle size={20} />
            <span>WhatsApp</span>
          </Link>
        </li>

        {/* Only Super Admin & SPV can see Tracking */}
        {canAccessTracking && (
          <li className={isActive('/tracking') ? 'active' : ''}>
            <Link to="/tracking">
              <Activity size={20} />
              <span>Tracking</span>
            </Link>
          </li>
        )}

        {/* Only Super Admin & SPV can see User Management */}
        {canManageUsers && (
          <li className={isActive('/users') ? 'active' : ''}>
            <Link to="/users">
              <Users size={20} />
              <span>User Management</span>
            </Link>
          </li>
        )}
      </ul>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="btn-logout">
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route path="/*" element={
          <PrivateRoute>
            <div className="app">
              <Navigation />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/upload" element={<Upload />} />
                  <Route path="/whatsapp" element={<WhatsAppConnect />} />
                  <Route path="/tracking" element={<Tracking />} />
                  <Route path="/users" element={<UserManagement />} />
                </Routes>
              </main>
            </div>
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;